module.exports = __webpack_public_path__ + "img/blank-profile-picture.3b9b92f9.png";